import { Box } from '@material-ui/core';
import { AssetType, Channel, getMerchantStructureByMerchantId, postCreateAgent } from '@nemuru-eng/js-api-client';
import React, { Dispatch, SetStateAction } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { CreateAgentForm } from '@/components/shared/components/CreateAgentDialog/components/CreateAgentForm';
import { CreateAgentSchema } from '@/components/shared/components/CreateAgentDialog/schemas/CreateAgentSchema';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface CreateAgentDialog {
  merchantId: string;
  currentChannel: Channel;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
}

export const CreateAgentDialog: React.FC<CreateAgentDialog> = ({
  merchantId,
  currentChannel,
  opened,
  setOpened,
  toggleDialog,
}) => {
  const { revalidate } = useCache(getMerchantStructureByMerchantId, { merchantId }, { revalidateOnMount: false });
  const { request, loading } = useRequest();

  const onSubmitForm = async (useFormValues: FormValues) => {
    await request(postCreateAgent, {
      channelId: currentChannel.id,
      id: uuidv4(),
      name: useFormValues.name,
      email: useFormValues.email,
      allowedAssetTypes: useFormValues.allowedAssetTypes,
    });
    toggleDialog();
    revalidate();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'CREATE_AGENT'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      formSchema={CreateAgentSchema}
    >
      <>
        <Font variant={'body2'} color={'textSecondary'}>
          <Text tId={'AGENT_CREATION_FOR_CHANNEL_X'} dynamicDataTexts={[currentChannel.description]} />
        </Font>
        <Box mt={3} />
        <CreateAgentForm fieldVariant={FieldVariant.form} fullWidth />
      </>
    </EditDialogWrapper>
  );
};

interface FormValues {
  name: string;
  email: string;
  allowedAssetTypes: AssetType[];
}
